import { addDays, subtract } from 'date-and-time';
import moment from 'moment';

export const weeks = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export function checkDateFormatAndConvert(input) {
  const dateTime = moment(input, moment.ISO_8601, true);
  const time = moment(input, 'HH:mm:ss', true);

  if (dateTime.isValid()) {
    if (input.includes('T') || input.includes(' ')) {
      return getCurrentDateAndTime(input,true);
    } else {
      return getCurrentDate(input);
    }
  } else if (time.isValid()) {
    return convertTime24To12(time);
  } else {
    return input || "-";
  }
}

export function getDateRange(startDate: Date, endDate: Date, steps = 1) {
  const dateArray: Date[] = [];
  let currentDate: Date = new Date(startDate);

  while (currentDate <= new Date(endDate)) {
    dateArray.push(new Date(currentDate));
    currentDate.setUTCDate(currentDate.getUTCDate() + steps);
  }

  return dateArray;
}

export const getDateString = (unixTimeStamp: number) => {
  const date = new Date(unixTimeStamp * 1000);
  return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
};

export const getDate = (unixTimeStamp: string) => {
  const date = new Date(parseInt(unixTimeStamp) * 1000);
  return date;
};

export const formatDate = (date: Date, formate?: string) => {
  const today = new Date(date);
  const yyyy = today.getFullYear();
  let mm: number | string = today.getMonth() + 1; // Months start at 0!
  let dd: number | string = today.getDate();

  if (dd < 10) dd = '0' + dd.toString();
  if (mm < 10) mm = '0' + mm.toString();

  let formattedToday: any = '';
  if (formate === 'dd') {
    formattedToday = dd;
  } else if (formate === 'mm') {
    formattedToday = mm;
  } else {
    formattedToday = dd + '/' + mm + '/' + yyyy;
  }
  return formattedToday;
};

export const getTimeString = (date: Date) => {
  let hours: string | number = date.getHours();
  let minutes: string | number = date.getMinutes();
  let ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'
  if (hours.toString().length === 1) hours = '0' + hours;
  minutes = minutes < 10 ? '0' + minutes : minutes;
  let strTime = hours + ':' + minutes + ' ' + ampm;
  return strTime;
};

export const getEpochTimeStamp = (inputDate: string | Date | undefined) => {
  if (!inputDate) return '';
  const date = new Date(inputDate);
  const dateOnlyString = date.toISOString().substring(0, 10);
  return dateOnlyString;
  // if (!inputDate) return '';
  // return (date.getTime() / 1000).toString();
};

export const isValidDate = (given) => {
  return moment(given).isValid();
}

export const getCurrentDateAndTime = (given, into12format = false, toSend?) => {
  if(moment(given).isValid()) {
    if (toSend)
      return moment(given).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
    if (!into12format) {
      return moment.utc(given).local().format('YYYY-MM-DD HH:mm:ssZ');
    }
    return moment.utc(given).local().format('DD/MM/YYYY hh:mm A');
  }
  return moment.utc(new Date()).local().format('DD/MM/YYYY hh:mm A');
};

export const getCurrentDate = (given, toSend = false) => {
  if(moment(given).isValid()) {
    return moment(given).format(toSend ? 'YYYY-MM-DD' : 'DD/MM/YYYY');
  }
  return moment(new Date()).format(toSend ? 'YYYY-MM-DD' : 'DD/MM/YYYY');
};

export const getCurrentTime = given => {
  const outputFormat = 'HH:mm:ss';
  const format = moment(given).local().format(outputFormat);
  return format === 'Invalid date' ? convertTime24To12(given) : format;
};

export function convertTime24To12(time24, foramte = '') {
  let outputFormat = 'hh:mm A';
  if (foramte) {
    outputFormat = foramte;
  }
  return !!time24 ? moment(time24, 'HH:mm:ss').format(outputFormat) : "-";
}

export function convertTime12to24(time12) {
  const inputFormat = 'h:mm A';
  const outputFormat = 'HH:mm:ss';
  return !!time12 ? moment(time12, inputFormat).format(outputFormat) : "-";
}

export const paginationOptions = [10, 20, 25, 50, 100, 200, 500, 1000, 1500, 2000, 3000, 4000, 5000];

export const timeRegex = /^([1-9]|0[1-9]|1[0-2]):[0-5][0-9]$/;

export const compareDates = (T1: Date, T2: Date) => {
  const date1 = new Date(T1);
  const date2 = new Date(T2);

  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

export const convertTimeIntoObj = (given, reverse = false) => {
  if (!reverse) {
    if (typeof given === 'string') {
      const [hours, minutes] = given.split(':').map(num => parseInt(num, 10));
      return {
        hours: hours,
        minutes: minutes,
      };
    }
  } else {
    if (typeof given !== 'string' && !!given?.hours) {
      return `${given?.hours?.toString()?.padStart(2, '0')}:${given.minutes
        ?.toString()
        ?.padStart(2, '0')}`;
    }
    return given;
  }
  return given;
};
export const getTimeZone = () => {
  const date = new Date();
  const timeZoneOffset = date.getTimezoneOffset();
  const hoursOffset = Math.floor(Math.abs(timeZoneOffset) / 60);
  const minutesOffset = Math.abs(timeZoneOffset) % 60;
  const sign = timeZoneOffset > 0 ? '-' : '+';
  const timeZone =
    sign +
    (hoursOffset < 10 ? '0' + hoursOffset : hoursOffset) +
    ':' +
    (minutesOffset < 10 ? '0' + minutesOffset : minutesOffset);
  return timeZone;
};

export const dayAgo = dateString => {
  const now = moment();
  const date = moment(dateString || new Date());
  const diff = now.diff(date, 'days');

  return diff === 0 ? 'Today' : `${diff} day${diff > 1 ? 's' : ''} ago`;
};

export const dateGap = dateString => {
  const today = moment();

  // Define the ending date
  const endDate = moment(dateString || new Date());

  // Calculate the date gap
  const duration = moment.duration(endDate.diff(today));
  return duration.asDays().toFixed();
};

export const compareTwoDates = (dateString1, dateString2) => {
  const date1 = moment(dateString1 || new Date());
  const date2 = moment(dateString2 || new Date());

  return date1.isBefore(date2);
};

export const convertFileNameIntoDateTime = (name) => {

  const dateString = name?.split("/")?.pop();

  const formatString = 'YYYY-MM-DD_HH-mm-ss-SSSSSSS';

  // Parse the input string with the specified format
  const parsedDate = moment(dateString, formatString);

  // Convert to local date and time
  const localDate = moment.utc(parsedDate).local();

  // Format the local date and time as a string
  const localDateString = localDate.format('DD/MM/YYYY');

  return localDateString;
}

export const combineDateAndTime = (dateString, timeString) => {
  // Combine date and time using Moment.js
  return new Date(moment(`${dateString} ${timeString}`, "DD/MM/YYYY HH:mm").toDate());
}

export const getYesterDayDate = () => {
  // Get the current date and time
  const currentDate = moment();

  // Subtract one day to get the previous date
  const previousDate:any = currentDate.subtract(1, 'days');

  return new Date(previousDate);
}

export const extractTimeFromDate = (given) => {
  const formattedTime = moment(given).format('HH:mm:ss');
  return formattedTime;
}